import React from 'react';

export const TagCard = ({ tag, displayType, onClick, actions }) => {
    return (
        <div className={`tag-card ${displayType}`} onClick={onClick}>
            {displayType === 'list' ? (
                <>
                    <div className="content">
                        <h3>{tag.name}</h3>
                        <p>{tag.description}</p>
                    </div>
                    <div className="model-actions">
                        {actions}
                    </div>
                </>
            ) : (
                <>
                    <h3>{tag.name}</h3>
                    <p>{tag.description}</p>
                    <div className="model-actions">
                        {actions}
                    </div>
                </>
            )}
        </div>
    );
};

export default TagCard;
